import { useGroupRules, UserGroupRules } from 'src/graphql';

interface MembershipsPermissions {
  loading: boolean;
  canEditMembershipsConfig: boolean;
  canManageLandingPages: boolean;
}

export const useMembershipsPermissions = (): MembershipsPermissions => {
  const { checkValidity, loading } = useGroupRules();

  return {
    loading,
    canEditMembershipsConfig:
      !loading && checkValidity([UserGroupRules.AccessToConfigureMemberships]),
    canManageLandingPages:
      !loading && checkValidity([UserGroupRules.AccessToManageLandingPages]),
  };
};
